define('lq/deviceId',[
    'uuid'
], function (uuid) {
    'use strict';

    // first (very simple) implementation
    
    const storageKey = "licquidDeviceId";
    
    var getId = function () {
        let id = localStorage.getItem(storageKey);

        if (!id) {
            id = uuid();
            localStorage.setItem(storageKey, id);
        }
        
        return id;
    };

    const id = getId();

    return {
        get: function() {
            return id;
        }
    };
});
